import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flags',
  templateUrl: './flags.component.html',
  styleUrls: ['./flags.component.css'],
  standalone: false,
})
export class FlagsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
